// function adjustMainPadding() {
//   var headerHeight = $(".header-wrapper").outerHeight(); // get full header height
//   $(".main-content").css("padding-top", headerHeight + "px");
// }

// $(document).ready(function () {
//   adjustMainPadding(); // run on load
// });

// $(window).on("resize", function () {
//   adjustMainPadding(); // run on resize for responsiveness
// });




function adjustMainPadding() {
  var headerHeight = $(".header-wrapper").outerHeight();
  $(".main-content").css("padding-top", headerHeight + "px");
}

$(document).ready(function () {
  adjustMainPadding();
});

let resizeTimer;
$(window).on("resize", function () {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function () {
    adjustMainPadding();
  }, 200); // runs 200ms after resize stops
});